import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "mr-2" }
const _hoisted_3 = {
  key: 0,
  class: "text-muted status"
}

import CoreUiOperatorAvatar from "~/core-ui/vue/chat/CoreUiOperatorAvatar.vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {computed} from "vue";
import getOperatorDisplayName from "~/operatorApplication/ts/service/operators/getOperatorDisplayName";
import getOperatorStatusDescr from "~/operatorApplication/vue/dialogs/dialog/sidemenu/getOperatorStatusDescr";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "OperatorApplicationForwardButtonOperator"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    operator: {},
    siteId: {}
  },
  setup(__props: any) {

let props = __props;

let customOperatorStatusDictionary = OperatorAccountStore.customStatusDictionary;

let customOperatorStatus = computed(() => {
    return customOperatorStatusDictionary.value[props.operator.customStatusId];
});

let showDialogCount = computed(() => {
    return OperatorAccountStore.data.value.accessRights.canViewOperatorDialogCount;
});

let statusDescr = computed(() => {
    return getOperatorStatusDescr(props.operator);
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CoreUiOperatorAvatar, {
        operator: __props.operator,
        size: "2.3em",
        "show-status": !!__props.operator.statusId,
        "status-color": _unref(customOperatorStatus)?.color,
        "show-dialog-count": _unref(showDialogCount)
      }, null, 8, ["operator", "show-status", "status-color", "show-dialog-count"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", null, _toDisplayString(_unref(getOperatorDisplayName)(__props.operator)), 1),
      (_unref(statusDescr))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(statusDescr)), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})